import './CasPanel.scss';

import { Card, CardProps } from '@mui/material';

interface ICasPanel {
  children: React.ReactNode;
  color?: 'primary' | 'danger' | 'warning' | 'disabled' | 'info';
  variant?: CardProps['variant'];
  maxHeight?: string;
  className?: string;
}

export default function CasPanel({ color, children, variant, maxHeight, className }: ICasPanel) {
  const bgColor = {
    primary: '#ecffec', // light green color
    danger: '#fff2f4', // light red color
    warning: '#fbf3c0', // light yellow
    disabled: '#EBEBEB', // light gray
    info: '#d9f0ff', // light blue
  };

  return (
    <Card
      sx={{
        backgroundColor: color ? bgColor[color] : undefined,
        ...(maxHeight && {
          maxHeight,
          overflowY: 'auto',
        }),
      }}
      className={`CasPanel ${className} ${color}`}
      variant={variant}
    >
      {children}
    </Card>
  );
}
